import React from 'react';
import {
  TableElement,
  useTableElementState,
} from '@udecode/plate';

import { PlateTablePopover } from './PlateTablePopover';

export const PlateTableElement = (props) => {
  const { as, children, ...rootProps } = props;

  const {
    colSizes,
    minColumnWidth,
    marginLeft,
  } = useTableElementState();

  return (
    <PlateTablePopover>
      <TableElement.Wrapper style={{ paddingLeft: marginLeft }}>
        <TableElement.Root
          {...rootProps}
        >
          <TableElement.ColGroup>
            {colSizes.map((width, index) => (
              <TableElement.Col
                key={index}
                style={{
                  minWidth: minColumnWidth,
                  width: width || undefined,
                }}
              />
            ))}
          </TableElement.ColGroup>

          <TableElement.TBody>
            {children}
          </TableElement.TBody>
        </TableElement.Root>
      </TableElement.Wrapper>
    </PlateTablePopover>
  );
};
